import React from 'react'
import { useTranslation } from 'react-i18next'

import { Body2 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { TradingViewIcon } from '@ui/icons/platforms/TradingView.icon'

import { Box } from '@shared/components/Box'

interface ChartToolbarProps {
  onChartOpen: () => void
}

export const ChartToolbar: React.FC<ChartToolbarProps> = ({ onChartOpen }) => {
  const { t } = useTranslation()

  return (
    <Box
      flex
      direction='row'
      justify='center'
      align='center'
      gap='x8'
      radius='x16'
      border='outline-low-em'
      py='x4'
      mt='x16'
    >
      <Box flex direction='row' gap='x4'>
        <TradingViewIcon />
        <Body2 medium>{t('Chart By TradingView')}</Body2>
      </Box>
      <Button size='xs' variant='secondary' onClick={onChartOpen}>
        {t('Show')}
      </Button>
    </Box>
  )
}
